<template>
  <div class="row">
    <loading
      class="custom-loading-overlay"
      :active="isLoading"
      :color="loadingColor"
      :isFullPage="true"
    ></loading>
    <div class="col-12" style="padding-left: 5px; padding-right: 5px">
      <div
        @click="view(ocorrencia.id)"
        class="card card-style"
        v-for="ocorrencia in ocorrencias"
        style="background-color: white; margin-left: 0px; margin-right: 0px"
        :key="ocorrencia.ocorrencia_id"
      >
        <div class="card-body">
          <h3 class="card-title">
            Atendimento: {{ ocorrencia.ocorrencia_id }}
          </h3>
          <h5>Data solicitação: {{ ocorrencia.data_gravacao }}</h5>
          <h5>
            Vítima:
            {{
              ocorrencia.paciente
                ? ocorrencia.paciente.nome_paciente
                : ocorrencia.nome_vitima
            }}
          </h5>
          <h5>
            Idade:
            {{
              ocorrencia.paciente
                ? ocorrencia.paciente.idade
                : ocorrencia.idade_vitima
            }}
          </h5>
          <h5>
            Sexo:
            {{
              ocorrencia.paciente
                ? ocorrencia.paciente.sexo
                : ocorrencia.sexo_vitima
            }}
          </h5>
          <h5>
            Queixa:
            {{ ocorrencia.queixa_principal }}
          </h5>
          <h5>
            Situação:
            {{
              ocorrencia.status_desc
                ? ocorrencia.status_desc.nome
                : "Aguardando atendimento"
            }}
          </h5>
        </div>
      </div>

      <p
        class="sem-registros"
        v-if="ocorrencias.length == 0"
        style="text-align: center; margin-top: 78%; font-size: 16px"
      >
        Nenhum atendimento solicitado. <br />
        Clique no botão abaixo para solicitar.
      </p>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
export default {
  data() {
    return {
      isLoading: false,
      loadingColor: "#5D9CEC",
      /* ocorrencias: {
        latitude: 0,
        longitude: 0,
        queixa_principal: "",
        ip: "",
        paciente_id: 0,
        usuario_solicitante_id: 0,
        paciente: {
          nome_paciente: '',
        },
      }, */
      ocorrencias: [],
      usr_id: {
        usuario_id: "",
      },
      usuario_nome: "",
    };
  },
  computed: {
    exibirStatus() {
      return this.ocorrencias.map((ocorrencia) => {
        if (ocorrencia.status === 0) {
          return "Solicitado";
        } else if (ocorrencia.status === 1) {
          return "Em Andamento";
        } else if (ocorrencia.status === 2) {
          return "Finalizado";
        } else if (ocorrencia.status === 3) {
          return "Cancelado";
        } else {
          return ocorrencia.status.toString();
        }
      });
    },
  },
  methods: {
    /* changeStatusReceive(object) {
      const self = this;
      const api = self.$store.state.api + "teste";

      self.isLoading = true;

      self.$http
        .post(api, object)
        .then((response) => {})
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    }, */
    view(id) {
      const self = this;
      /* self.isLoading = true */
      this.$router.push("/visualizar-atendimento/" + id);
      /* this.$router.push({
        path: this.$router + "/editar-paciente/" + id,
      }); */
    },
    getOcorrencias(id) {
      const self = this;
      self.isLoading = true;

      this.usr_id.usuario_id = Number(id);
      const api = self.$store.state.api + "usuario-ocorrencias-finalizadas";

      axios
        .post(api, this.usr_id)
        .then((response) => {
          self.ocorrencias = response.data;
          self.isLoading = false;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.isLoading = false;
        })
        .finally(() => {
          self.isLoading = false;
        });
    },
  },
  components: { Loading },
  props: {},
  mounted() {
    const self = this;

    self.isLoading = true;

    var id = localStorage.getItem("usuario_id");

    self.getOcorrencias(id);

    this.authenticated = this.$store.getters.authenticated;

    $("body").removeClass("top-navigation");
    $("body").removeClass("custom-login");

    $("#menu-main").removeClass("show");
    $(".offcanvas-backdrop.show").removeClass("show");
    /* $(".theme-light").removeAttribute("style","overflow: hidden; padding-right: 0px;"); */
    document.body.setAttribute("style", null);

    /*  var usr_nome = localStorage.getItem('usuario_nome');
    this.usuario_nome = usr_nome; */
  },
};
</script>
<style scoped>
/* CUSTOMIZACOES VUE LOADING */
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}

/* CUSTOMIZACOES INPUTS */
.custom-input {
  border-radius: 0;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group > .form-control {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
}

.input-group > .form-control:focus {
  z-index: 3;
}

.custom-input-container {
  position: relative;
}

.custom-input {
  padding: 0.375rem 0.75rem;
  height: 2.714rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: 0 0.2rem 0.5rem rgba(0, 0, 0, 0.15);
  width: 100%;
}

.custom-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.botao-cadastrar {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
}

.sem-registros {
  position: fixed;
  bottom: 50%;
  width: 100%;
  /* padding-left: 10px;
  padding-right: 10px; */
}

.btn {
  width: 100% !important;
  background-color: rgb(21, 72, 138) !important;
  margin: 0px 15px 18px -29px;
}

h5 {
  font-weight: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/UltimasSolicitacoes.vue